/*
 * LoginController.tsx
 * Login Controller.
 *
 * Created by Nick Perry on 8/9/22.
 *
 *
 * Copyright © 2009-2022 United States Government as represented by
 * the Program Manager of the DHA: Web and Mobile Technology Program Management Office.
 * All Rights Reserved.
 *
 * Copyright © 2009-2022 Contributors. All Rights Reserved.
 *
 * THIS OPEN SOURCE AGREEMENT ("AGREEMENT") DEFINES THE RIGHTS OF USE,
 * REPRODUCTION, DISTRIBUTION, MODIFICATION AND REDISTRIBUTION OF CERTAIN
 * COMPUTER SOFTWARE ORIGINALLY RELEASED BY THE UNITED STATES GOVERNMENT
 * AS REPRESENTED BY THE GOVERNMENT AGENCY LISTED BELOW ("GOVERNMENT AGENCY").
 * THE UNITED STATES GOVERNMENT, AS REPRESENTED BY GOVERNMENT AGENCY, IS AN
 * INTENDED THIRD-PARTY BENEFICIARY OF ALL SUBSEQUENT DISTRIBUTIONS OR
 * REDISTRIBUTIONS OF THE SUBJECT SOFTWARE. ANYONE WHO USES, REPRODUCES,
 * DISTRIBUTES, MODIFIES OR REDISTRIBUTES THE SUBJECT SOFTWARE, AS DEFINED
 * HEREIN, OR ANY PART THEREOF, IS, BY THAT ACTION, ACCEPTING IN FULL THE
 * RESPONSIBILITIES AND OBLIGATIONS CONTAINED IN THIS AGREEMENT.
 *
 * Government Agency: DHA: Web and Mobile Technology Program Management Office
 * Government Agency Original Software Designation: dha-dha-login
 * Government Agency Original Software Title: dha-dha-login
 * User Registration Requested. Please send email
 * with your contact information to: robert.a.kayl.civ@mail.mil
 * Government Agency Point of Contact for Original Software - Program Manager: robert.a.kayl.civ@mail.mil
 */

import { useState } from 'react';

import { useSelector } from 'react-redux';

import AccountSetup from '../pages/Login/AccountSetup';
import Login from '../pages/Login/Login';
import NewPin from '../pages/Login/NewPin';
import PinReset from '../pages/Login/PinReset';

// without this, the controller wouldn't know what the accountState slice should look like in a pwa
interface IAccountState {
  accountState: { created: boolean };
}

export type IPinResetStatusState = {
  answeringSecurityQuestions: boolean;
  makingNewPin: boolean;
};

export const initialState = {
  answeringSecurityQuestions: false,
  makingNewPin: false,
};

const LoginController = () => {
  const existingAccount = useSelector((state: IAccountState) => state.accountState.created);

  const [pinResetStatus, setPinResetStatus] = useState<IPinResetStatusState>(initialState);

  if (!existingAccount) {
    return <AccountSetup />;
  }

  if (pinResetStatus.answeringSecurityQuestions) {
    return <PinReset setPinResetStatus={setPinResetStatus} />;
  } else if (pinResetStatus.makingNewPin) {
    return <NewPin setPinResetStatus={setPinResetStatus} />;
  }

  return <Login setPinResetStatus={setPinResetStatus} />;
};

export default LoginController;
